import { ComponentType } from "react";

import alvysApi from "../../../../api/factoring/alvys";
import AlvysIntegrationPanel from "./components/AlvysIntegration/AlvysIntegrationPanel";
import { hasCredentials } from "./components/AlvysIntegration/helpers";

export interface IntegrationStatus {
  available: boolean;
  added: boolean;
}

export interface IntegrationCardProps {
  factoringId: string;
  openSnackbar: (variant: string, message: string) => void;
}

export interface Integration {
  key: string;
  name: string;
  description: string;
  permission: string;
  brokersOnly: boolean;
  loadStatus: (factoringId: string) => Promise<IntegrationStatus>;
  Card: ComponentType<IntegrationCardProps>;
}

const alvys: Integration = {
  key: "alvys",
  name: "Alvys",
  description: "Loads invoiced in Alvys become funding requests here.",
  permission: "admin-factor_client-profile:Alvys",
  brokersOnly: true,
  loadStatus: async (factoringId: string): Promise<IntegrationStatus> => {
    const connection = await alvysApi.getAlvysConnection(factoringId);
    return {
      available: connection.available,
      added: connection.enabled || hasCredentials(connection)
    };
  },
  Card: AlvysIntegrationPanel
};

export const INTEGRATIONS: Integration[] = [alvys];

export const canAdd = (status?: IntegrationStatus): boolean =>
  Boolean(status && status.available && !status.added);
